import {ISSUE_ATTRIBUTE_NAMES} from './issue-attribute-names';

export const ACTIVITY_VERBS = {
  CREATE: 'quality-issue-create',
  OPEN: 'quality-issue-open',
  CLOSED: 'quality-issue-closed',
  PENDING: 'quality-issue-pending',
  IN_REVIEW: 'quality-issue-in-review',
  EDIT: 'quality-issue-edit',
  DUE_DATE: 'quality-issue-due-date',
  ASSIGN: 'quality-issue-assign',
  COMMENT: 'quality-issue-comment',
  REFERENCE_ADDED: 'issue-link-added',
  REFERENCE_REMOVED: 'issue-link-removed',
  ATTACH: 'quality-issue-attach',
  RESPOND: 'quality-issue-respond',
  ANSWERED: 'quality-issue-answered',
  WORK_COMPLETED: 'quality-issue-work-completed',
  READY: 'quality-issue-ready-to-inspect',
  VOID: 'quality-issue-void',
  DETACH: 'quality-issue-detach',
  NOT_APPROVED: 'quality-issue-not-approved',
  IN_DISPUTE: 'quality-issue-in-dispute'
};

export const IssuesActivityFieldNameMapping = {
  [ISSUE_ATTRIBUTE_NAMES.STATUS]: 'activity.nameMapping.status',
  [ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO]: 'activity.nameMapping.assignTo',
  [ISSUE_ATTRIBUTE_NAMES.DUE_DATE]: 'activity.nameMapping.dueDate',
  [ISSUE_ATTRIBUTE_NAMES.OWNER_ID]: 'activity.nameMapping.issueOwner',
  [ISSUE_ATTRIBUTE_NAMES.ROOT_CAUSE_ID]: 'activity.nameMapping.rootCause',
  [ISSUE_ATTRIBUTE_NAMES.ISSUE_TYPE_ID]: 'activity.nameMapping.type',
  [ISSUE_ATTRIBUTE_NAMES.ISSUE_TYPE_ID]: 'activity.nameMapping.type',
  [ISSUE_ATTRIBUTE_NAMES.ISSUE_SUB_TYPE_ID_ACTIVITY]: 'activity.nameMapping.subType',
  [ISSUE_ATTRIBUTE_NAMES.LOCATION_ID]: 'activity.nameMapping.location',
  [ISSUE_ATTRIBUTE_NAMES.LOCATION_DETAILS]: 'activity.nameMapping.locationDetails',
  [ISSUE_ATTRIBUTE_NAMES.TITLE]: 'activity.nameMapping.titleChanged',
  [ISSUE_ATTRIBUTE_NAMES.DESCRIPTION]: 'activity.nameMapping.descriptionChanged',
  [ISSUE_ATTRIBUTE_NAMES.DELETED_AT]: 'activity.nameMapping.deletedAt',
  [ISSUE_ATTRIBUTE_NAMES.OFFICIAL_RESPONSE]: 'activity.nameMapping.responseChanged',
  targetUrn: 'activity.nameMapping.targetUrn'
};

export const activityChangeType = {
  ChangedTitle: 'changed_title',
  ChangedPublished: 'changed_published',
  ChangedStatus: 'changed_status',
  ChangedIssueType: 'changed_issue_type_id',
  ChangedIssueSubtype: 'changed_issue_subtype_id',
  ChangedDescription: 'changed_description',
  ChangedAssignedTo: 'changed_assigned_to',
  ChangedStartDate: 'changed_start_date',
  ChangedDueDate: 'changed_due_date',
  ChangedLocationDescription: 'changed_location_description',
  ChangedBody: 'changed_body',
  ChangedRootCause: 'changed_root_cause_id',
  ChangedCustomAttributes: 'changed_custom_attributes',
  ChangedReference: 'changed_link',
  ChangedWatchers: 'changed_watchers',
  ChangedTargetUrn: 'changed_target_urn',
  ChangedAnswer: 'changed_answer',
  ChangedLbsLocation: 'changed_lbs_location',
  ChangedAttachmentType: 'changed_attachment_type',
  ChangedDeletedAt: 'changed_deleted_at',
  ChangedName: 'changed_name',
  ChangedAssignedToType: 'changed_assigned_to_type',
  ChangedOwner: 'changed_owner',
  ChangedUrn: 'changed_urn'
};

export const ACTIVITY_CHANGE_TYPES = [
  activityChangeType.ChangedTitle,
  activityChangeType.ChangedPublished,
  activityChangeType.ChangedStatus,
  activityChangeType.ChangedIssueType,
  activityChangeType.ChangedIssueSubtype,
  activityChangeType.ChangedDescription,
  activityChangeType.ChangedAssignedTo,
  activityChangeType.ChangedStartDate,
  activityChangeType.ChangedDueDate,
  activityChangeType.ChangedLocationDescription,
  activityChangeType.ChangedBody,
  activityChangeType.ChangedRootCause,
  activityChangeType.ChangedCustomAttributes,
  activityChangeType.ChangedReference,
  activityChangeType.ChangedWatchers,
  activityChangeType.ChangedTargetUrn,
  activityChangeType.ChangedAnswer,
  activityChangeType.ChangedLbsLocation,
  activityChangeType.ChangedAttachmentType,
  activityChangeType.ChangedDeletedAt,
  activityChangeType.ChangedName,
  activityChangeType.ChangedAssignedToType,
  activityChangeType.ChangedOwner,
  activityChangeType.ChangedUrn
];

export const IssueCreateActivityFieldNameMapping = {
  [ISSUE_ATTRIBUTE_NAMES.TITLE]: 'activity.nameMapping.title',
  [ISSUE_ATTRIBUTE_NAMES.DESCRIPTION]: 'activity.nameMapping.description'
};

export const IssuesActivityIgnoredFields = [
  ISSUE_ATTRIBUTE_NAMES.COMMENT_BODY,
  ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO_TYPE,
  ISSUE_ATTRIBUTE_NAMES.ATTACHMENT
];

export const ActivityBatchReadTypes = {
  PREVIOUS: 'previous',
  LATEST: 'latest'
};

export const ActivityQueryParams = {
  pageLimit: 20
};

export const ACTIVITY_THRESHOLD = 5;
